import { AtiraApi } from "../AxiosClient";

export class TemplateAxios {
  static getTemplate() {
    return AtiraApi.get(`/template`).then(({ data }) => data);
  }
}
